// extracted by mini-css-extract-plugin
module.exports = {"tablepd":"index_tablepd_1vJNf","locked":"index_locked_1zWZx"};